var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"link-button"},[_c('v-btn',{attrs:{"fab":"","x-small":"","text":"","color":_vm.color,"to":_vm.to,"title":_vm.title,"disabled":_vm.disabled},on:{"click":_vm.update_details}},[_c('v-icon',[_vm._v(_vm._s(_vm.faIcon(_vm.icon)))])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }